import React from "react";
import "./Functionality.css";

const Functionality = () => {
  return (
    <div className="functionality">
      <div className="wrapper">
        <div className="functionality-intro-heading">
          <h2>Fragment:</h2>
        </div>
      </div>
      <div className="functionality-specialization">
        <h3></h3>
        <p>(fragment I)</p>
        <p>Akt II</p>
        <p>SCENA 3</p>
        <p>
          ISIA, CHOCHOŁ
          <br />
          CHOCHOŁ
          <br />
          I Kto mnie wołał
          <br />
          czego chciał-
          <br />
          zebrałem się,
          <br />
          w com ta miał:
          <br />
          jestem, jestem
          <br />
          na Wesele,
          <br />
          przyjedzie tu
          <br />
          gości wiele,
          <br />
          żeby ino wicher wiał.
          <br />
          Co się w duszy komu gra,
          <br />
          co kto w swoich widzi snach:
          <br />
          czy to grzech,
          <br />
          czy to śmiech,
          <br />
          czy to kapcan, czy to pan,
          <br />
          na Wesele przyjdzie w tan.
        </p>
        <br />
        <p>(fragment II)</p>
        <p>SCENA 9</p>
        <p>POETA, RYCERZ.</p>
        <p>
          POETA
          <br />
          Otwarła się toń!
          <br />
          Upomina się o swoje Umarła.
          <br />
          Szumem, gwarnością, zawrotem
          <br />
          idzie ku nam z powrotem;
          <br />
          jakaś Przemoc wrotom grobu się wydarła,
          <br />
          oto, słyszę, woła:
        </p>
        <p>
          RYCERZ
          <br />
          Daj dłoń!!
        </p>
        <p>
          POETA
          <br />
          Puszczaj!
        </p>
        <p>
          RYCERZ
          <br />
          Ty mój!
        </p>
        <p>
          POETA
          <br />
          Puszczaj!
        </p>
        <p>
          RYCERZ
          <br />
          Ty mój!!
        </p>
        <p>
          POETA
          <br />
          Żelazem owita ręka,
          <br />
          żelazem zakryta skroń.
        </p>
        <p>
          RYCERZ
          <br />
          Zbieraj się, skrzydlaty ptaku,
          <br />
          nędzarzu, na koń, na koń,
          <br />
          przepadnie przekleństwo, męka!
        </p>
        <p>
          POETA
          <br />
          Co mówisz, okropne widziadło,
          <br />
          na koń? &#8211; gdzie? &#8211; jak?
          <br />
          Żelazna twoja dzwoni szczęka,
          <br />
          żelazna więzi mnie ręka.
        </p>
        <p>
          RYCERZ
          <br />
          Na koń, zbudź się, ty żak,
          <br />
          ty lecieć masz jak ptak!
          <br />
          Bioręć w pętle.
        </p>
        <p>
          POETA
          <br />
          Na arkan mnie wiąże.
        </p>
        <p>
          RYCERZ
          <br />
          Poznasz, ktom jest, gdy zaciążę-
          <br />
          ty więzień mój, mnie służ;
          <br />
          biorę przemocą. Ja Moc:
          <br />
          za mną, przede mną
          <br />
          ognia kurz;
          <br />
          po drogach, po których lecę,
          <br />
          drzewa się palą jak świece,
          <br />
          ciskają się błyskawice,
          <br />
          jak lecę, Duch:
          <br />
          wytężaj, wytężaj słuch!
          <br />
          […]
          <br />
          A czy wiesz, czym ty masz być,
          <br />o czym tobie marzyć, śnić?
        </p>
        <p>
          POETA
          <br />
          Sen, marzenie, mara, wid:
        </p>
        <p>
          RYCERZ
          <br />
          Jutro dzień! przede dniem świt!
          <br />
          Wiesz ty, czym ty mogłeś być?
        </p>
        <p>
          POETA
          <br />
          Słowo, Widmo gończe!
        </p>
        <p>
          RYCERZ
          <br />
          Zwiastun!!
        </p>
        <p>
          POETA
          <br />
          Głos jak marzeń moich piastun;
          <br />
          Rycerz, Widmo, urojenie
          <br />
          przyoblekło szatę żywą.
        </p>
        <p>
          RYCERZ
          <br />
          Krwi, krwi pragnę, krwawe żniwo!
          <br />
          Wracam do dom w noc szczęśliwą,
          <br />
          w noc ponurych wichrów łkań.
          <br />
          Niosę dań, orężną dań.
          <br />
          […]
          <br />
          Na głos mój ty będziesz drżał:
          <br />
          Grunwald, miecze, król Jagiełło!
          <br />
          Hajno się po zbrojach cięło,
          <br />
          a wichr wył i dął, i wiał;
          <br />
          stosy trupów, stosy ciał,
          <br />
          a krew rzeką płynie, rzeką!
          <br />
          Tam to jest!! Olbrzymów dzieło;
          <br />
          Witołd, Zawisza, Jagiełło,
          <br />
          tam to jest!! &#8211; Z pobojowiska
          <br />
          zbroica się w skibach przebłyska,
          <br />
          żelezce, połamane groty,
          <br />
          drzewce powbijane do ciał,
          <br />
          z trupów zapora, z trupów wał,
          <br />
          rycerski zgotowiony stos:
          <br />
          Ofiarnica-
          <br />
          tam leć &#8211; tam chodź, tam leć!!!
          <br />
          brać z tej zbrojowni zbroje,
          <br />
          kopije, miecz i szczyt
          <br />
          i stać tam wśród krwi,
          <br />
          aż na ogromny głos
          <br />
          bladością się powlecze świt,
          <br />
          a ciała wstaną,
          <br />
          a zbroje wzejdą
          <br />
          i pochwycą kopije, i przejdą!!!
          <br />
          Spiesz, tam leżą stosy ciał;
          <br />
          przeparłem trumniska wieko,
          <br />
          czas, bym wstał, czas, bym wstał.
        </p>
        <p>
          POETA
          <br />
          Łzy mnie pieką, łzy mnie pieką,
          <br />
          czymże bym ja tam być miał.
        </p>
        <p>
          RYCERZ
          <br />
          Niosę dań, orężny szał.
        </p>
        <p>
          POETA
          <br />
          Dech twój zimny, dech grobowy..:
        </p>
        <p>
          RYCERZ
          <br />
          Patrzaj w twarz, patrz mi w twarz,
          <br />
          ślubuj duszę, duszę dasz.
        </p>
        <p>
          POETA
          <br />
          Za przyłbicą pustość, proch;
          <br />
          w oczach twoich czarny loch,
          <br />
          za przyłbicą Noc;
          <br />
          zbroja głuchym jękiem brzękła.
        </p>
        <br />
      </div>
      <br />
      <p>
        <em>aleklasa.pl/matura/c266-lektury-klucze-maturalne/wesele-matura</em>
      </p>
    </div>
  );
};

export default Functionality;
